import * as React from "react";

import "./Icon.css";
const SvgHomeIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <path d="M24.19 0 0 18.05V48h15.49V28.66h17.02V48H48V18.15z" />
  </svg>
);

export default SvgHomeIcon;
